<template>
	<v-row>
		<v-col cols="12" class="actions-col">
			<div class="actions">
				<v-btn
					depressed
					outlined
					@click="download"
					:loading="isDownloading"
					:disabled="isDownloading || loading"
				>
					<v-icon class="mr-1" v-if="!isDownloading">mdi-download</v-icon>
					{{ isDownloading ? 'Downloading...' : 'Download' }}
				</v-btn>
				<v-btn depressed outlined :disabled="loading" @click="showPrintModal = !showPrintModal">
					<v-icon class="mr-1">mdi-printer</v-icon> Print
				</v-btn>
				<v-btn depressed outlined :disabled="loading" @click="$router.back()">Cancel</v-btn>
			</div>
		</v-col>

		<v-col v-show="false" cols="12">
			<div v-for="(purchaseOrder, i) in info" :key="i">
				<article :class="`print-${purchaseOrder.purchaseOrderId}`">
					<div class="print-wrapper" :class="{ 'po-cancelled': purchaseOrder.isCancelled }">
						<!-- Page identification footer for pagination - PagedJS moves this to margin -->
						<div class="page-id-footer">
							<span class="doc-id">PO-{{ purchaseOrder.purchaseOrderId }}</span>
							<span class="separator"> | </span>
							<span class="page-number"></span>
							<span class="separator"> | </span>
							<span class="printed-info">{{ (purchaseOrder.orderNumber.startsWith("7") || purchaseOrder.orderNumber.startsWith("9")) ? "Stock PO" : "Processing PO" }} {{ processTypes.find((pt) => pt.processTypeId === purchaseOrder.processTypeId)?.name || "" }} - Printed on {{ getCentralTimeDate() }} at {{ getCentralTime() }} by {{ getPrintedBy(purchaseOrder) }}</span>
						</div>
						<section class="print-heading">
							<div class="print-heading-left">
								<p>
									<b>TeamLeader</b>
								</p>

								<p>
									2901 Summit Ave. #300
									<br />
									Plano, TX 75074
								</p>

								<p>Phone: 1-877-365-7555</p>
							</div>

							<div class="print-heading-center">
								<div class="print-heading-logo">
									<img
										src="data:image/svg+xml;base64,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"
										alt="teamleader logo"
									/>
								</div>
							</div>

							<div class="print-heading-right">
								<span class="print-heading-type">PURCHASE ORDER</span>

								<p>
									<b>#{{ purchaseOrder.orderNumber }}</b>
								</p>
								<p class="header-page-number"></p>
							</div>
						</section>

						<section class="print-info">
							<div class="print-info-container-split">
								<table>
									<thead>
										<tr>
											<th>Vendor</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<p>{{ purchaseOrder.companyName }}</p>
												<p>{{ purchaseOrder.vendorAddress.label }}</p>
												<p v-if="purchaseOrder.vendorAddress.addressLine1?.length > 0">
													{{ purchaseOrder.vendorAddress.addressLine1 }}
													{{ purchaseOrder.vendorAddress.addressLine2 }}
												</p>
												<p v-if="purchaseOrder.vendorAddress.city?.length > 0">
													{{ purchaseOrder.vendorAddress.city }},
													{{ purchaseOrder.vendorAddress.state }}
													{{ purchaseOrder.vendorAddress.postalCode }}
												</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div class="print-info-container-split">
								<table>
									<thead>
										<tr>
											<th>Ship To</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td v-if="info && purchaseOrder.dropShip">
												<p>{{ getContactName(purchaseOrder.shipTo, purchaseOrder) }}</p>
												<p v-if="getOrganization(purchaseOrder.shipTo)">
													{{ getOrganization(purchaseOrder.shipTo) }}
												</p>
												<p v-if="getAddress(purchaseOrder.shipTo, 'addressLine1', purchaseOrder)?.length > 0">
													{{ getAddress(purchaseOrder.shipTo, "addressLine1", purchaseOrder) }}
													{{ getAddress(purchaseOrder.shipTo, "addressLine2", purchaseOrder) }}
												</p>
												<p v-if="getAddress(purchaseOrder.shipTo, 'city', purchaseOrder)?.length > 0">
													{{ getAddress(purchaseOrder.shipTo, "city", purchaseOrder) }},
													{{ getAddress(purchaseOrder.shipTo, "state", purchaseOrder) }}
													{{ getAddress(purchaseOrder.shipTo, "postalCode", purchaseOrder) }}
												</p>
											</td>
											<td v-else>
												<p>TeamLeader</p>
												<p>2901 Summit Ave. #300</p>
												<p>Plano, TX 75074</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</section>

						<section class="print-info">
							<div class="print-info-container-full">
								<table>
									<thead>
										<tr>
											<th>PO Date</th>
											<th>Reqd Date</th>
											<th>Ordered By</th>
											<th>Ship Via</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<p>{{ formatDate(purchaseOrder.orderDate) }}</p>
											</td>
											<td>
												<p>{{ formatDate(purchaseOrder.expectedDate) }}</p>
											</td>
											<td>
												<p>{{ purchaseOrder.orderedBy }}</p>
											</td>
											<td>
												<p>
													{{
														renderShippingMethod(
															purchaseOrder.shippingMethodId || shippingMethodId
														) || "-"
													}}
												</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</section>

						<section class="print-items">
							<div class="print-items-container">
								<table>
									<thead>
										<tr>
											<th>Qty</th>
											<th>Item #</th>
											<th>Description</th>
											<th>Unit Price</th>
											<th>Amount</th>
										</tr>
									</thead>
									<tbody>
										<template v-for="(item, idx) in purchaseOrder.items">
											<!-- Item -->
											<tr :key="`item-${idx}`">
												<td>{{ item.quantity }}</td>
												<td>
													<p v-if="purchaseOrder.isAttaching" class="print-items-title">ATTACH</p>
													<p v-else class="print-items-title">
														{{
															(
																processTypes.find(
																	(pt) => pt.processTypeId === item.itemOrdered.processTypeId
																)?.name || ""
															).toUpperCase()
														}}
													</p>
													<p class="print-items-title">
														<span
																v-if="
																	$systemCategories.isSubItem(
																		item?.itemOrdered?.systemCategoryId ?? item.systemCategoryId
																	)
																"
																style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"
															><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>
														{{ item.itemOrdered.vendorPartNumber || item.styleCode }}
													</p>
													<p>&nbsp;</p>
												</td>
												<td>
													<p v-if="purchaseOrder.isAttaching" class="print-items-title">
														Attach {{ item?.itemOrdered?.systemCategory }} to
														{{ item.parentItem?.itemOrdered?.systemCategory }}
													</p>
													<p v-else class="print-items-title">
														{{
															(
																processTypes.find(
																	(pt) => pt.processTypeId === item.itemOrdered.processTypeId
																)?.description || ""
															).toUpperCase()
														}}
													</p>
													<p class="print-items-title">Order# {{ purchaseOrder.orderNumber }}</p>
													<p
														class="print-items-title"
														v-if="
															purchaseOrder.receivedItems &&
															purchaseOrder.receivedItems.length > 0 &&
															purchaseOrder.receivedItems?.reduce(
																(sum, item) => sum + item.quantityReceived,
																0
															) > 0
														"
													>
														Received {{ formatMostRecentReceivedDate(purchaseOrder.receivedItems) }}
													</p>
													<p class="print-items-title">{{ item.description }}</p>
													<p
														style="font-weight: normal; font-style: italic"
														v-if="item.note"
														v-html="formatNewLines(item.note)"
													></p>
													<div>
														<div v-for="(color, idx) in item.colorSelections || []" :key="idx">
															{{ color?.colorOption
															}}<template v-if="color?.colorDescription"
																>:{{ color?.colorDescription }}</template
															><template v-if="color?.description || color?.color || color?.label || color?.text"
																>:{{ color?.description || color?.color || color?.label || color?.text }}</template
															>
														</div>
														<span v-if="item.matchPreviousPoNumber">
															Previous PO: #{{ item.matchPreviousPoNumber }}
														</span>
													</div>
													<template v-if="item.lettering && item.lettering.text">
														<p v-if="item.lettering.letterPositionId">
															{{
																letterPositions.find(
																	(lp) => lp.letterPositionId === item.lettering.letterPositionId
																)?.description || ''
															}}
														</p>
														<p>"{{ item.lettering.text }}"</p>
													</template>
													<p
														v-if="
															(item.sizeSelections && item.sizeSelections.length > 0) ||
															(item.specialSizeSelections && item.specialSizeSelections.length > 0)
														"
													>
														<template
															v-for="(size, sizeIndex) in mergeAndSortAllSizes(item)"
														>
															<span :key="sizeIndex" class="size-item">{{
																size
															}}<template
																v-if="sizeIndex < mergeAndSortAllSizes(item).length - 1"
																>,
															</template></span>
														</template>
													</p>
												</td>
												<td>
													<p class="print-items-value">{{ renderPrice(item.unitPrice) }}</p>
												</td>
												<td>
													<p class="print-items-value">{{ renderItemTotal(item) }}</p>
												</td>
											</tr>

											<!-- SubItems (SystemCategory -> IncludeWithParentPO = true) -->
											<template v-if="item.childItems && item.childItems.length > 0">
												<tr
													v-for="(subItem, sidx) in getFilteredSubItems(item)"
													:key="`subItem-${idx}-${sidx}`"
												>
													<td></td>
													<td>
														<p v-if="subItem.itemOrdered?.processTypeId" class="print-items-title">
															{{
																(
																	processTypes.find(
																		(pt) => pt.processTypeId === subItem.itemOrdered?.processTypeId
																	)?.name || ""
																).toUpperCase()
															}}
														</p>
														<p class="print-items-title">
															<span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>
															{{
																subItem.itemOrdered.vendorPartNumber ||
																subItem.itemOrdered.styleCode
															}}
														</p>
														<p>&nbsp;</p>
													</td>
													<td>
														<p class="print-items-title">{{ subItem.itemOrdered.description }}</p>
														<p
															class="print-items-title"
															v-if="
																subItem.receivedItems &&
																subItem.receivedItems.length > 0 &&
																subItem.receivedItems?.reduce(
																	(sum, item) => sum + item.quantityReceived,
																	0
																) > 0
															"
														>
															Received
															{{ formatMostRecentReceivedDate(subItem.receivedItems) }}
														</p>
														<p v-if="subItem.braidPosition" class="print-items-title">
															{{ subItem.braidPosition }}
														</p>
														<p
															style="font-weight: normal; font-style: italic"
															v-if="subItem.note"
															v-html="formatNewLines(subItem.note)"
														></p>
														<div>
															<div
																v-for="(color, idx) in item.childItems.find(
																	(ch) => ch.salesOrderLineItemId === subItem.salesOrderLineItemId
																)?.colorSelections || []"
																:key="idx"
															>
																{{ color?.colorOption
																}}<template v-if="color?.colorDescription"
																	>:{{ color?.colorDescription }}</template
																><template v-if="color?.description || color?.color || color?.label || color?.text"
																	>:{{ color?.description || color?.color || color?.label || color?.text }}</template
																>
															</div>
														</div>
														<p v-if="subItem.matchPreviousPoNumber">
															Previous PO: #{{ subItem.matchPreviousPoNumber }}
														</p>
														<template v-if="subItem.lettering && subItem.lettering.text">
															<p v-if="subItem.lettering.letterPositionId">
																{{
																	letterPositions.find(
																		(lp) =>
																			lp.letterPositionId === subItem.lettering.letterPositionId
																	)?.description || ''
																}}
															</p>
															<p>"{{ subItem.lettering.text }}"</p>
														</template>
													</td>
													<td></td>
													<td></td>
												</tr>
											</template>

											<!-- Stock SubItems from subItems array (IncludeWithParentPO = true AND no processType) -->
											<template v-if="getFilteredStockSubItems(item).length > 0">
												<tr
													v-for="(subItem, sidx) in getFilteredStockSubItems(item)"
													:key="`stockSubItem-${idx}-${sidx}`"
												>
													<td></td>
													<td>
														<p class="print-items-title">
															<span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>
															{{
																subItem.itemOrdered.vendorPartNumber ||
																subItem.itemOrdered.styleCode
															}}
														</p>
														<p>&nbsp;</p>
													</td>
													<td>
														<p class="print-items-title">{{ subItem.itemOrdered.description }}</p>
														<p v-if="subItem.braidPosition" class="print-items-title">
															{{ subItem.braidPosition }}
														</p>
														<p
															style="font-weight: normal; font-style: italic"
															v-if="subItem.note"
															v-html="formatNewLines(subItem.note)"
														></p>
														<div>
															<div
																v-for="(color, colorIdx) in subItem.colors || []"
																:key="colorIdx"
															>
																{{ color?.colorOption
																}}<template v-if="color?.description"
																	>:{{ color?.description }}</template
																><template v-if="color?.color"
																	>:{{ color?.color }}</template
																>
															</div>
														</div>
														<p v-if="subItem.matchPreviousPoNumber">
															Previous PO: #{{ subItem.matchPreviousPoNumber }}
														</p>
														<template v-if="subItem.lettering && subItem.lettering.text">
															<p v-if="subItem.lettering.letterPositionId">
																{{
																	letterPositions.find(
																		(lp) =>
																			lp.letterPositionId === subItem.lettering.letterPositionId
																	)?.description
																}}
															</p>
															<p>"{{ subItem.lettering.text }}"</p>
														</template>
													</td>
													<td></td>
													<td></td>
												</tr>
											</template>

											<!-- ParentItem -->
											<tr
												v-if="shouldRenderParentItem(item) || purchaseOrder.isAttaching"
												style="background-color: lightgray"
												:key="`parentItem-${idx}`"
											>
												<td colspan="5" style="padding: 4px !important">Applies to Item Below</td>
											</tr>
											<template v-if="shouldRenderParentItem(item) || purchaseOrder.isAttaching">
												<tr :key="idx">
													<td>{{ item.parentItem.quantity }}</td>
													<td>
														<p
															v-if="item.parentItem.itemOrdered?.processTypeId"
															class="print-items-title"
														>
															{{
																(
																	processTypes.find(
																		(pt) =>
																			pt.processTypeId ===
																			item.parentItem?.itemOrdered?.processTypeId
																	)?.name || ""
																).toUpperCase()
															}}
														</p>
														<p class="print-items-title">
															{{
																item.parentItem.itemOrdered?.vendorPartNumber ||
																item.parentItem.itemOrdered?.styleCode
															}}
														</p>
														<p>&nbsp;</p>
													</td>
													<td>
														<p
															v-if="item.parentItem?.itemOrdered?.processTypeId"
															class="print-items-title"
														>
															{{
																(
																	processTypes.find(
																		(pt) =>
																			pt.processTypeId ===
																			item.parentItem?.itemOrdered?.processTypeId
																	)?.description || ""
																).toUpperCase()
															}}
														</p>
														<p v-if="!purchaseOrder.isAttaching" class="print-items-title">
															Order#
															{{
																item.parentItem.purchaseOrderNumber ||
																purchaseOrder.orderNumber.split("-")[0]
															}}
															Line#
															{{ item.parentItem.lineNumber }}
														</p>
														<p
															v-else-if="item.parentItem.purchaseOrderNumber"
															class="print-items-title"
														>
															Order# {{ item.parentItem.purchaseOrderNumber }}
														</p>
														<p
															class="print-items-title"
															v-if="
																item.parentItem.receivedItems &&
																item.parentItem.receivedItems.length > 0 &&
																item.parentItem.receivedItems?.reduce(
																	(sum, item) => sum + item.quantityReceived,
																	0
																) > 0
															"
														>
															Received
															{{ formatMostRecentReceivedDate(item.parentItem.receivedItems) }}
														</p>
														<p class="print-items-title">
															{{ item.parentItem.itemOrdered?.description }}
														</p>
														<p
															style="font-weight: normal; font-style: italic"
															v-if="item.parentItem.note"
															v-html="formatNewLines(item.parentItem.note)"
														></p>
														<div>
															<div
																v-for="(color, idx) in item.parentItem?.colorSelections ||
																item.parentItem?.colors ||
																[]"
																:key="idx"
															>
																{{ color?.colorOption
																}}<template v-if="color?.colorDescription"
																	>:{{ color?.colorDescription }}</template
																><template v-if="color?.description || color?.color || color?.label || color?.text"
																	>:{{ color?.description || color?.color || color?.label || color?.text }}</template
																>
															</div>
															<span v-if="item.parentItem.matchPreviousPoNumber">
																Previous PO: #{{ item.parentItem.matchPreviousPoNumber }}
															</span>
														</div>
														<template
															v-if="item.parentItem.lettering && item.parentItem.lettering.text"
														>
															<p v-if="item.parentItem.lettering.letterPositionId">
																{{
																	letterPositions.find(
																		(lp) =>
																			lp.letterPositionId ===
																			item.parentItem.lettering.letterPositionId
																	)?.description || ''
																}}
															</p>
															<p>"{{ item.parentItem.lettering.text }}"</p>
														</template>
														<p
															v-if="mergeAndSortAllSizes(item.parentItem).length > 0"
														>
															<template
																v-for="(size, sizeIndex) in mergeAndSortAllSizes(item.parentItem)"
															>
																<span :key="sizeIndex" class="size-item">{{
																	size
																}}<template
																	v-if="sizeIndex < mergeAndSortAllSizes(item.parentItem).length - 1"
																	>,
																</template></span>
															</template>
														</p>
													</td>
													<td>
														<p class="print-items-value">
															{{ renderPrice(item.parentItem.unitPrice) }}
														</p>
													</td>
													<td>
														<p class="print-items-value">{{ renderItemTotal(item.parentItem) }}</p>
													</td>
												</tr>

											<!-- Sibling same-category items (e.g. other monograms) -->
											<template v-if="getSiblingItems(item).length > 0">
												<tr
													v-for="(sibling, sibIdx) in getSiblingItems(item)"
													:key="`sibling-${idx}-${sibIdx}`"
												>
													<td>{{ sibling.quantity }}</td>
													<td>
														<p
															v-if="sibling.itemOrdered?.processTypeId"
															class="print-items-title"
														>
															{{
																(
																	processTypes.find(
																		(pt) => pt.processTypeId === sibling.itemOrdered?.processTypeId
																	)?.name || ""
																).toUpperCase()
															}}
														</p>
														<p class="print-items-title">
															<span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>
															{{
																sibling.itemOrdered?.vendorPartNumber ||
																sibling.itemOrdered?.styleCode
															}}
														</p>
														<p>&nbsp;</p>
													</td>
													<td>
														<p class="print-items-title" v-if="sibling.purchaseOrderNumber">
															PO# {{ sibling.purchaseOrderNumber }}
														</p>
														<p class="print-items-title">{{ sibling.itemOrdered?.description }}</p>
														<p
															style="font-weight: normal; font-style: italic"
															v-if="sibling.note"
															v-html="formatNewLines(sibling.note)"
														></p>
														<div>
															<div
																v-for="(color, cIdx) in sibling.colorSelections || []"
																:key="cIdx"
															>
																{{ color?.colorOption
																}}<template v-if="color?.colorDescription"
																	>:{{ color?.colorDescription }}</template
																><template v-if="color?.description || color?.color || color?.label || color?.text"
																	>:{{ color?.description || color?.color || color?.label || color?.text }}</template
																>
															</div>
														</div>
														<template v-if="sibling.lettering && sibling.lettering.text">
															<p v-if="sibling.lettering.letterPositionId">
																{{
																	letterPositions.find(
																		(lp) => lp.letterPositionId === sibling.lettering.letterPositionId
																	)?.description || ''
																}}
															</p>
															<p>"{{ sibling.lettering.text }}"</p>
														</template>
														<p v-if="mergeAndSortAllSizes(sibling).length > 0">
															<template
																v-for="(size, sizeIndex) in mergeAndSortAllSizes(sibling)"
															>
																<span :key="sizeIndex" class="size-item">{{
																	size
																}}<template
																	v-if="sizeIndex < mergeAndSortAllSizes(sibling).length - 1"
																	>,
																</template></span>
															</template>
														</p>
													</td>
													<td>
														<p class="print-items-value">{{ renderPrice(sibling.unitPrice) }}</p>
													</td>
													<td>
														<p class="print-items-value">{{ renderItemTotal(sibling) }}</p>
													</td>
												</tr>
											</template>
											</template>

											<!-- Processing -->
											<tr
												v-if="getFilteredProcessSubItems(item)?.length > 0"
												class="print-divider"
												style="background-color: lightgray"
												:key="`processing-${idx}`"
											>
												<td colspan="5" style="padding: 4px !important">Additional Processing</td>
											</tr>
											<template v-if="item.subItems && item.subItems.length > 0">
												<tr
													v-for="(subItem, sidx) in getFilteredProcessSubItems(item)"
													:key="`processSubItem-${idx}-${sidx}`"
												>
													<td>
														<template v-if="!isBraid(subItem) || !item.parentItem">
															{{
																item.childItems.find(
																	(ch) => ch.salesOrderLineItemId === subItem.salesOrderLineItemId
																)?.quantity
															}}
														</template>
													</td>
													<td>
														<p v-if="subItem.isAttaching" class="print-items-title">ATTACH</p>
														<p
															v-else-if="subItem.itemOrdered?.processTypeId"
															class="print-items-title"
														>
															{{
																(
																	processTypes.find(
																		(pt) => pt.processTypeId === subItem.itemOrdered?.processTypeId
																	)?.name || ""
																).toUpperCase()
															}}
														</p>
														<p class="print-items-title">
															<span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>
															{{
																subItem.itemOrdered.vendorPartNumber ||
																subItem.itemOrdered.styleCode
															}}
														</p>
														<p>&nbsp;</p>
													</td>
													<td>
														<p v-if="subItem.isAttaching" class="print-items-title">
															Attach {{ subItem?.itemOrdered?.systemCategory }} to
															{{ item?.itemOrdered?.systemCategory }}
														</p>
														<p v-if="subItem.purchaseOrderNumber ||
															item.childItems.find(
																(ch) => ch.salesOrderLineItemId === subItem.salesOrderLineItemId
															)?.purchaseOrderNumber" class="print-items-title">
															Order#
															{{
																subItem.purchaseOrderNumber ||
																item.childItems.find(
																	(ch) => ch.salesOrderLineItemId === subItem.salesOrderLineItemId
																)?.purchaseOrderNumber
															}}
														</p>
														<p class="print-items-title">{{ subItem.itemOrdered.description }}</p>
														<p v-if="subItem.braidPosition" class="print-items-title">
															{{ subItem.braidPosition }}
														</p>
														<p
															style="font-weight: normal; font-style: italic"
															v-if="subItem.note"
															v-html="formatNewLines(subItem.note)"
														></p>
														<div>
															<div
																v-for="(color, idx) in item.childItems.find(
																	(ch) => ch.salesOrderLineItemId === subItem.salesOrderLineItemId
																)?.colorSelections || []"
																:key="idx"
															>
																{{ color?.colorOption
																}}<template v-if="color?.colorDescription"
																	>:{{ color?.colorDescription }}</template
																><template v-if="color?.description || color?.color || color?.label || color?.text"
																	>:{{ color?.description || color?.color || color?.label || color?.text }}</template
																>
															</div>
														</div>
														<p v-if="subItem.matchPreviousPoNumber">
															Previous PO: #{{ subItem.matchPreviousPoNumber }}
														</p>
														<template v-if="subItem.lettering && subItem.lettering.text">
															<p v-if="subItem.lettering.letterPositionId">
																{{
																	letterPositions.find(
																		(lp) =>
																			lp.letterPositionId === subItem.lettering.letterPositionId
																	)?.description || ''
																}}
															</p>
															<p>"{{ subItem.lettering.text }}"</p>
														</template>
													</td>
													<td></td>
													<td></td>
												</tr>
											</template>
										</template>
									</tbody>
									<tfoot v-if="!purchaseOrder.salesOrderId">
										<tr class="order-total-row">
											<td colspan="4" class="order-total-label">Order Total</td>
											<td class="order-total-amount">{{ calculateOrderTotal(purchaseOrder) }}</td>
										</tr>
									</tfoot>
								</table>
							</div>
						</section>

						<!-- Print info now included in page-id-footer which appears on every page -->
					</div>
				</article>
			</div>
		</v-col>

		<!-- render live print pages from the print article -->
		<v-col cols="12" class="d-flex justify-center">
			<div
				v-if="loading"
				class="loading-overlay"
				:style="info.length > 1 ? 'height: 100vh; position: fixed;' : ''"
			>
				<div class="loading-dot">&nbsp;</div>
				<div class="loading-dot">&nbsp;</div>
				<div class="loading-dot">&nbsp;</div>
				<div class="loading-dot">&nbsp;</div>
				<div class="loading-dot">&nbsp;</div>
			</div>
			<ul class="no-list-style" style="width: 100%">
				<li v-for="(po, i) in info" :key="i">
					<iframe
						:id="`print-frame-${po.purchaseOrderId}`"
						:src="pdfUrls[po.purchaseOrderId]"
						class="print-frame"
						@load="onPdfIframeLoad(po.purchaseOrderId)"
					></iframe>
				</li>
			</ul>
		</v-col>

		<!-- Snackbar for notifications -->
		<v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top>
			<span class="text-h6">{{ snackbar.text || snackbar.message }}</span>
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
			</template>
		</v-snackbar>

		<v-overlay :dark="false" :absolute="false" :value="showPrintModal">
			<div class="input-modal print-modal">
				<div class="input-modal-header justify-space-between">
					<span class="ml-3">Print</span>
					<v-btn icon @click="showPrintModal = false">
						<v-icon v-text="'mdi-close'"></v-icon>
					</v-btn>
				</div>
				<div class="input-modal-content">
					<div class="print-modal-form">
						<div class="form-input">
							<label>Printer:</label>
							<v-select
								v-model="printerSelection"
								:items="printers"
								item-text="text"
								item-value="printerId"
								dense
								outlined
								hide-detail
							></v-select>
						</div>
						<div class="form-input">
							<label>Copies:</label>
							<v-text-field
								class="number-input"
								outlined
								dense
								hide-details="auto"
								v-model="copies"
								type="number"
								min="0"
							></v-text-field>
						</div>
						<div class="form-input">
							<label>Message:</label>
							<v-textarea
								v-model="printMessage"
								dense
								outlined
								hide-details="auto"
								rows="5"
								placeholder="Add optional message or notes for this print job"
								class="message-input"
							></v-textarea>
						</div>
					</div>

					<div class="input-modal-content-actions">
						<v-spacer></v-spacer>
						<div class="button-group">
							<v-btn text @click="showPrintModal = false" :disabled="isPrinting" class="mr-2">
								Cancel
							</v-btn>
							<v-btn
								color="primary"
								depressed
								@click="print()"
								:loading="isPrinting"
								:disabled="isPrinting || !isFormValid"
							>
								<v-icon left>mdi-printer</v-icon>
								Print
							</v-btn>
						</div>
					</div>
					<v-alert v-if="printResult.show" dense text :type="printResult.type" class="mt-3">
						{{ printResult.message }}
					</v-alert>
				</div>
			</div>
		</v-overlay>
	</v-row>
</template>

<script>
import gql from "graphql-tag";
import { PURCHASE_ORDER_BY_ID, CUSTOMER_ADDRESS_BY_ID, GET_SALES_ORDER } from "@/gql/queries";
import { VENDOR_BY_ID } from "@/gql/vendors";
import { GET_INVENTORY_COLOR_OPTIONS_IDS } from "@/gql/inventory";
import { renderPrice } from "@/helpers/PricingCalculator";
import { pagedJSService } from "@/services/PagedJSService";
export default {
	name: "PurchaseOrderPrintTemplate",
	props: {
		purchaseOrderIds: {
			type: Array,
			default: () => [],
		},
		customer: {
			type: Object,
			default() {
				return {};
			},
		},
		shippingMethodId: {
			type: Number,
			default() {
				return null;
			},
		},
		// Override for auto-print context where user name is passed via URL
		printedByOverride: {
			type: String,
			default: null,
		},
		skipPreview: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			paymentTerms: [],
			shippingMethods: [],
			showPrintModal: false,
			printMessage: "",
			messages: [],
			printerSelection: "",
			printers: [],
			copies: 1,
			info: [],
			loading: true,
			lineItems: [],
			orderId: null,
			shipToResults: [],
			salesOrder: null,
			isPrinting: false,
			isDownloading: false,
			printResult: {
				show: false,
				type: "success",
				message: "",
			},
			printJobId: null,
			snackbar: {
				show: false,
				color: "success",
				text: "",
				timeout: 5000,
			},
			pdfUrls: {},
			pdfReadySet: new Set(),
		};
	},
	apollo: {
		paymentTerms: {
			query() {
				return gql`
					query {
						paymentTerms(skip: 0, take: 15, order: { paymentTermsName: ASC }) {
							items {
								paymentTermsId
								paymentTermsName
							}
						}
					}
				`;
			},
			update: (data) => data.paymentTerms.items,
		},
		shippingMethods: {
			query() {
				return gql`
					query {
						shippingMethods(take: 500) {
							items {
								shippingMethodId
								shippingMethodName
							}
						}
					}
				`;
			},
			update: (data) => data.shippingMethods.items,
		},
		letterPositions: {
			query() {
				return gql`
					query {
						letterPosition(take: 500) {
							items {
								letterPositionId
								code
								description
							}
						}
					}
				`;
			},
			update: (data) => data.letterPosition.items,
		},
		processTypes: {
			query() {
				return gql`
					query {
						processTypes(take: 500) {
							items {
								processTypeId: id
								name
								description
								excludeAttachingOnParentPO
								requireAttaching
								includeParent
								sequence
							}
						}
					}
				`;
			},
			update(data) {
				return data.processTypes.items;
			},
		},
	},
	methods: {
		renderPrice,

		// Get current date in Central Time (America/Chicago) - Issue #1123
		getCentralTimeDate() {
			const now = new Date();
			return now.toLocaleDateString('en-US', {
				timeZone: 'America/Chicago',
				month: 'numeric',
				day: 'numeric',
				year: '2-digit'
			});
		},

		// Get current time in Central Time (America/Chicago) - Issue #1123
		getCentralTime() {
			const now = new Date();
			return now.toLocaleTimeString('en-US', {
				timeZone: 'America/Chicago',
				hour: 'numeric',
				minute: '2-digit',
				hour12: true
			}).toLowerCase();
		},

		// Extract initials from a name string - Issue #1123
		extractInitials(nameOrInitials) {
			if (!nameOrInitials) return '';
			if (nameOrInitials.length <= 3) return nameOrInitials.toUpperCase();
			const parts = nameOrInitials.trim().split(/\s+/);
			if (parts.length >= 2) {
				return (parts[0][0] + parts[1][0]).toUpperCase();
			}
			return nameOrInitials.substring(0, 2).toUpperCase();
		},

		// Get the "printed by" value as initials, prioritizing override prop for auto-print
		getPrintedBy(purchaseOrder) {
			// Priority 1: Override prop from auto-print URL (user who initiated the action)
			if (this.printedByOverride) {
				return this.extractInitials(this.printedByOverride);
			}

			// Priority 2: Logged-in user from store (manual print) - use initials
			let user = this.$store.getters.userInfo;
			if (user?.initials) {
				return user.initials;
			} else if (user?.firstName && user?.lastName) {
				return (user.firstName[0] + user.lastName[0]).toUpperCase();
			} else if (user?.username) {
				return user.username.substring(0, 2).toUpperCase();
			}

			// Priority 3: Fall back to orderedBy from the PO data (extract initials)
			if (purchaseOrder?.orderedBy) {
				return this.extractInitials(purchaseOrder.orderedBy);
			}

			// Final fallback for auto-print context where no user info exists
			return "AP";
		},
		formatDate(date) {
			if (!date) return "";

			date = date.substring(0, 10);
			const [year, month, day] = date.split("-");
			return `${month}/${day}/${year}`;
		},

		// Reqd Date defaults to 2 weeks after the PO date when not set (#1229).
		// Works on the date portion in UTC to avoid timezone drift — formatDate
		// only ever reads the first 10 chars (YYYY-MM-DD) of the result.
		addDaysToDate(date, days) {
			if (!date) return null;
			const datePart = date.substring(0, 10);
			const d = new Date(`${datePart}T00:00:00Z`);
			d.setUTCDate(d.getUTCDate() + days);
			return d.toISOString();
		},

		formatMostRecentReceivedDate(receivedItems) {
			if (!receivedItems || receivedItems.length === 0) {
				return "";
			}

			const mostRecentDate = receivedItems.reduce((latest, item) => {
				const currentDate = new Date(item.receivedDate);
				return currentDate > latest ? currentDate : latest;
			}, new Date(0));

			return this.formatDate(mostRecentDate.toISOString());
		},

		renderContact(shipTo) {
			return `${shipTo?.firstName?.trim() ?? ""} ${shipTo?.lastName?.trim() ?? ""}`;
		},

		// "Ordered By" shows the sales rep's initials when the PO originates
		// from a sales order; manual POs show the creator's initials (#1229).
		async renderOrderedBy(createdBy, salesRepId) {
			if (salesRepId) {
				try {
					const repRes = await this.$apollo.query({
						query: gql`
							query GetSalesRepById($salesRepId: Int!) {
								salesReps(where: { salesRepId: { eq: $salesRepId } }, take: 1) {
									items {
										salesRepId
										name
									}
								}
							}
						`,
						variables: { salesRepId },
						fetchPolicy: "no-cache",
					});

					const rep = repRes.data.salesReps?.items?.[0];
					if (rep?.name) {
						return this.extractInitials(rep.name);
					}
				} catch (error) {
					console.error("Error fetching sales rep:", error);
				}
			}

			try {
				const response = await this.$apollo.query({
					query: gql`
						query GetUserName($userId: Int!) {
							userNameById(userId: $userId) {
								fullName
								username
							}
						}
					`,
					variables: {
						userId: createdBy,
					},
					fetchPolicy: "no-cache",
				});

				const user = response.data.userNameById;
				return this.extractInitials(user?.fullName || user?.username || "");
			} catch (error) {
				console.error("Error fetching user:", error);
				return "";
			}
		},

		renderShippingMethod(shippingMethodId) {
			return this.shippingMethods.find((el) => el.shippingMethodId === shippingMethodId)
				?.shippingMethodName;
		},

		renderPaymentTerm(paymentTermsId) {
			let paymentTermById = this.paymentTerms.find((a) => a.paymentTermsId == paymentTermsId);
			return paymentTermById ? paymentTermById.paymentTermsName : null;
		},

		renderItemTotal(item) {
			let formatter = new Intl.NumberFormat("en-US", {
				style: "currency",
				currency: "USD",
			});

			let vendorCost = item.vendorCost ? parseFloat(item.vendorCost) : 0;
			let itemCost = item.cost ? parseFloat(item.cost) : 0;
			let quantity = item.quantity ? parseFloat(item.quantity) : 0;

			let itemTotal = 0;

			itemTotal += (itemCost + vendorCost) * quantity;
			return formatter.format(itemTotal.toFixed(2));
		},

		calculateOrderTotal(purchaseOrder) {
			let formatter = new Intl.NumberFormat("en-US", {
				style: "currency",
				currency: "USD",
			});

			let grandTotal = 0;

			for (const item of purchaseOrder.items || []) {
				let vendorCost = item.vendorCost ? parseFloat(item.vendorCost) : 0;
				let itemCost = item.cost ? parseFloat(item.cost) : 0;
				let quantity = item.quantity ? parseFloat(item.quantity) : 0;
				grandTotal += (itemCost + vendorCost) * quantity;
			}

			return formatter.format(grandTotal.toFixed(2));
		},

		buildSizeSequenceMap(sizeChart) {
			const idMap = new Map();
			const nameMap = new Map();
			if (!sizeChart || !sizeChart.sizes) {
				return { idMap, nameMap };
			}

			sizeChart.sizes.forEach(size => {
				const seq = size.sequence ?? 999;
				idMap.set(size.sizeId, seq);
				if (size.name) nameMap.set(size.name, seq);
			});

			return { idMap, nameMap };
		},

		mergeAndSortAllSizes(item) {
			if (!item) return [];

			// Access sizeChart from inventoryItem (not itemOrdered)
			const sizeChart = item.inventoryItem?.sizeChart;
			const { idMap, nameMap } = this.buildSizeSequenceMap(sizeChart);

			// Handle both field names: sizes/specialSizes (parentItem) and sizeSelections/specialSizeSelections (item)
			const normalSizesArray = item.sizes || item.sizeSelections || [];
			const specialSizesArray = item.specialSizes || item.specialSizeSelections || [];

			// Mark normal vs special sizes and add sequence
			const normalSizes = normalSizesArray.map(size => ({
				...size,
				isSpecial: false,
				sequence: idMap.get(size.sizeId) || 998
			}));

			const specialSizes = specialSizesArray.map(size => ({
				...size,
				isSpecial: true,
				sequence: nameMap.get(size.name || size.size) ?? 999
			}));

			// Merge arrays
			const allSizes = [...normalSizes, ...specialSizes];

			// Filter out zero quantities
			const validSizes = allSizes.filter(size =>
				size.quantity !== 0 && size.quantity !== ""
			);

			// Sort by sequence first, then by length
			validSizes.sort((a, b) => {
				if (a.sequence !== b.sequence) {
					return a.sequence - b.sequence;
				}
				const lengthA = a.length ? parseInt(a.length, 10) : 0;
				const lengthB = b.length ? parseInt(b.length, 10) : 0;
				return lengthA - lengthB;
			});

			// Format sizes with proper trimming and no space before slash
			return validSizes.map(size => {
				const sizeName = size.name || size.size || '';
				const length = size.length ? `/${size.length}` : '';
				return `${size.quantity}-${sizeName}${length}`.trim();
			});
		},

		renderSizes(sizeSelections, isSpecialSize) {
			let listOfSizes = [];

			sizeSelections.forEach((size) => {
				const sizeString = `${size.quantity}-${size.name || size.size} ${
					size.length ? `/${size.length}` : ""
				}`;

				if (size.quantity !== 0 && size.quantity !== "") {
					// special sizes should end with "
					if (!isSpecialSize) {
						listOfSizes.push(sizeString.trim());
					} else {
						listOfSizes.push(sizeString.trim() + '"');
					}
				}
			});

			return listOfSizes.join(", ");
		},

		shouldRenderProcessType(item) {
			if (item.itemOrdered && item.itemOrdered.processTypeId) {
				const processType = this.processTypes.find(
					(pt) => pt.processTypeId === item.itemOrdered.processTypeId
				);

				return processType && processType.processTypeId;
			}

			return false;
		},

		shouldRenderParentItem(item) {
			if (item.itemOrdered && item.itemOrdered.processTypeId) {
				const processType = this.processTypes.find(
					(pt) => pt.processTypeId === item.itemOrdered.processTypeId
				);

				if (processType && processType.processTypeId) {
					return (
						(item.parentItem.parentPoId || item.parentItem.parentLineItemId) &&
						(processType.includeParent || processType.processTypeId === 3)
					); // Monogram
				}
			}

			return false;
		},

		shouldRenderSubItem(item) {
			let includeWithParentPoResult = false;
			let sysCatId =
				item.itemOrdered.systemCategoryId > 0
					? item.itemOrdered.systemCategoryId
					: item.systemCategoryId;
			let systemCategory = this.$systemCategories.getSystemCategory(sysCatId);

			if (systemCategory) {
				includeWithParentPoResult = systemCategory.includeWithParentPO;
			}

			return includeWithParentPoResult;
		},

		getFilteredSubItems(item) {
			// Exclude items with processTypeId - those belong in "Additional Processing" section
			return item.childItems.filter(
				(subItem) => this.shouldRenderSubItem(subItem) && !subItem?.itemOrdered?.processTypeId
			);
		},

		getSiblingItems(item) {
			// Siblings are a non-attaching monogram feature; never show them on an attaching PO.
			if (this.purchaseOrder && this.purchaseOrder.isAttaching) return [];
			let sysCatId =
				item.itemOrdered?.systemCategoryId > 0
					? item.itemOrdered.systemCategoryId
					: item.systemCategoryId;
			let systemCategory = this.$systemCategories.getSystemCategory(sysCatId);
			if (!systemCategory || !systemCategory.includeSiblingOnPO) return [];
			return item.siblingItems || [];
		},

		isBraid(subItem) {
			const sysCatId = subItem?.itemOrdered?.systemCategoryId > 0
				? subItem.itemOrdered.systemCategoryId
				: subItem?.systemCategoryId;
			return sysCatId === 16;
		},

		getFilteredStockSubItems(item) {
			return (item.subItems || []).filter((subItem) => {
				if (!this.shouldRenderSubItem(subItem)) return false;
				const isStockItem = subItem?.itemOrdered?.isStock === true;
				const hasNoProcessType = !subItem?.itemOrdered?.processTypeId;
				if (!isStockItem && !hasNoProcessType) return false;
				if (this.isBraid(subItem)) return false;
				const alreadyInChildItems = (item.childItems || []).some(
					(ch) => ch.salesOrderLineItemId === subItem.salesOrderLineItemId
				);
				return !alreadyInChildItems;
			});
		},

		lookupLineNumber(salesOrderLineItemId) {
			if (!salesOrderLineItemId) return 0;
			const li = this.lineItems?.find((l) => l.lineItemId === salesOrderLineItemId);
			return li?.lineNumber || 0;
		},

		getFilteredProcessSubItems(item) {
			let subItems = item.subItems.filter(
				(subItem) => subItem?.itemOrdered?.processTypeId > 0 && !subItem?.itemOrdered?.isStock
			);

			let stockBraids = (item.subItems || []).filter((subItem) => {
				if (!this.shouldRenderSubItem(subItem)) return false;
				if (!this.isBraid(subItem)) return false;
				if (!subItem?.itemOrdered?.isStock) return false;
				const alreadyIncluded = subItems.some(
					(s) => s.salesOrderLineItemId === subItem.salesOrderLineItemId
				);
				return !alreadyIncluded;
			});

			let filteredAttachItems = item.attachItems.filter((attachItem) => {
				const parentProcessType = this.processTypes.find(
					(pt) => pt.processTypeId === item.itemOrdered.processTypeId
				);
				return !parentProcessType?.excludeAttachingOnParentPO;
			});

			let allItems = [...(subItems || []), ...stockBraids, ...filteredAttachItems];
			return allItems.sort((a, b) => {
				const aNum = a.lineNumber || this.lookupLineNumber(a.salesOrderLineItemId) || 0;
				const bNum = b.lineNumber || this.lookupLineNumber(b.salesOrderLineItemId) || 0;
				return aNum - bNum;
			});
		},

		async print() {
			this.isPrinting = true;
			this.printResult = {
				show: false,
				type: "success",
				message: "",
			};

			try {
				// Form validation
				if (!this.isFormValid) {
					if (!this.printerSelection) {
						this.printResult = {
							show: true,
							type: "error",
							message: "Please select a printer",
						};
					} else if (!this.copies || this.copies <= 0) {
						this.printResult = {
							show: true,
							type: "error",
							message: "Please enter a valid number of copies",
						};
					}
					this.isPrinting = false;
					return;
				}

				// Generate the print documents for each PO
				for (let po of this.info) {
					//get Html to print
					let printHTML = document.querySelector(`.print-${po.purchaseOrderId}`).parentElement
						.innerHTML;
					/* eslint-disable */
					// Use local PagedJS - no CDN dependencies
					const pagedJsScript = pagedJSService.getPagedJSScriptTag({
			inline: false
		});

					let printDoc = `<!DOCTYPE html>
					<html>
					<head>
						${pagedJsScript}
						<script>
							class Sanitize extends Paged.Handler
							{
								constructor(chunker, polisher, caller) {
									super(chunker, polisher, caller);
								}

								afterPageLayout(pageFragment, page) {
									//console.log(pageFragment);
									const contentElements = document.querySelectorAll('.pagedjs_page_content');
									contentElements.forEach(element => {
										let style = element.getAttribute("style");
										if (style) {
											style = style.replace(/column-width:[^;]+;?/, '');
											element.setAttribute("style", style);
										}
									});
								}

								afterRendered(pages) {
									// Set completion flag for server-side PDF generation
									window.__pagedjs_complete = true;

									// Fix "Page X of 0" - counter(pages) is unreliable in running elements
									const totalPages = pages.length;
									document.querySelectorAll('.pagedjs_page').forEach((pageEl, index) => {
										const pageNumberEl = pageEl.querySelector('.page-number');
										if (pageNumberEl) {
											pageNumberEl.textContent = 'Page ' + (index + 1) + ' of ' + totalPages;
										}
									});
								}
							}
							Paged.registerHandlers(Sanitize);
						<\/script>
						<style type="text/css">
						*, ::after, ::before { box-sizing: border-box; margin: 0; padding: 0; }
						body{counter-reset: page;}
						@page { size: Letter; margin: 0.4cm; margin-top: 3cm; margin-bottom: 0.9cm; @top-center{content:element(pageHeader)} @bottom-center{content:element(pageIdFooter)} }
						.print-${po.purchaseOrderId} { position: relative; display: contents; background-color: #fff; line-height: 14pt; font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif !important; width: 100%; }
						.print-wrapper { height: 100%; }
						.po-cancelled { position: relative; opacity: 0.45; }
						.po-cancelled::after { content: "CANCELLED"; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(-18deg); font-size: 6rem; font-weight: 900; letter-spacing: 1rem; color: rgba(0, 0, 0, 0.08); white-space: nowrap; pointer-events: none; z-index: 1; }
						.page-id-footer{position:running(pageIdFooter);font-family:Arial,sans-serif;font-size:9pt;color:#555;text-align:center;padding:4px 0}
						.page-id-footer .page-number::after{content:none}
						.print-heading { position: running(pageHeader); display: block; }
						.print-heading p { font-size: 12pt; font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif; margin-bottom: 8px !important; }
						.print-heading-logo { display: block; width: 100%; text-align: center; }
						.print-heading-logo img { max-width: 70%; height: auto; }
						.print-heading-type { display: inline-block; width: 100%; padding: 4px; margin-bottom: 8px; text-align: center; font-size: 10pt; background-color: #000; color: #fff; }
						.header-page-number::after { content: "Page " counter(page); }
						.print-heading-left { display: inline-block; width: 25%; text-align: left; vertical-align: top; }
						.print-heading-center { display: inline-block; width: 50%; vertical-align: top; }
						.print-heading-right { display: inline-block; width: 25%; font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif; text-align: right; vertical-align: top; }
						.print-info { display: flex; margin-bottom: 8px; }
						.print-info-container-split { display: flex; width: 48%; }
						.print-info-container-split:last-child { margin-left: 4%; }
						.print-info-container-split table { width: 100%; border-spacing: 0px; font-size: 10pt; border: 1px solid #000; }
						.print-info-container-split table thead tr { page-break-inside: avoid; }
						.print-info-container-split table thead tr th { padding: 4px; background-color: #000; color: #fff; text-align: center; font-weight: 400; }
						.print-info-container-split table tbody tr { page-break-inside: avoid; }
						.print-info-container-split table tbody tr td { padding: 5px; padding-left: 15px; display: flex; flex-direction: column; }
						.print-info-container-split table tbody tr td p:nth-child(4) { margin-bottom: 20px !important; }
						.print-info-container-full { display: block; width: 100%; }
						.print-info-container-full table { width: 100%; border-spacing: 0px; font-size: 10pt; border: 1px solid #000; }
						.print-info-container-full table thead tr { page-break-inside: avoid; }
						.print-info-container-full table thead tr th { padding: 4px; background-color: #000; color: #fff; text-align: center; font-weight: 400; }
						.print-info-container-full table tbody tr { page-break-inside: avoid; }
						.print-info-container-full table tbody tr td { padding: 4px; text-align: center; border-right: 1px solid #000; }
						.print-info-container-full table tbody tr td:last-child { border-right: none; }
						.print-items { display: block; }
						.print-items-container { display: block; width: 100%; }
						.print-items-container table { width: 100%; border-spacing: 0px; border: 1px solid #000; }
						.print-items-container table thead tr { page-break-inside: avoid; }
						.print-items-container table thead tr th { font-size: 10pt; padding: 4px 2px; background-color: #000; color: #fff; text-align: center; font-weight: 400; }
						.print-items-container table tbody tr { break-inside: avoid; page-break-inside: avoid; }
						.print-items-container table tbody tr td { font-size: 9pt; vertical-align: top; padding:3px 2px; text-align: center; border-right: 1px solid #000; line-height:14px }
						.print-items-container table tbody tr td:last-child { border-right: none; }
						.print-items-container table tbody tr td:nth-child(1) { width: 50px; }
						.print-items-container table tbody tr td:nth-child(2) { width: 16%; text-align: left; }
						.print-items-container table tbody tr td:nth-child(3) { text-align: left; }
						.print-items-container table tbody tr td:nth-child(4) { width: 16%; text-align: right; }
						.print-items-container table tbody tr td:nth-child(5) { width: 16%; text-align: right; }
						.print-items-title { font-weight: 700; }
						.print-items-value { font-weight: 700; }
						.print-items-container table tfoot tr td { font-size: 10pt; font-weight: 700; padding: 8px 4px; border-top: 2px solid #000; background-color: #f2f2f2; }
						.print-items-container table tfoot tr td.order-total-label { text-align: right; padding-right: 8px; }
						.print-items-container table tfoot tr td.order-total-amount { text-align: right; }
						.print-footer { position: absolute; bottom: -15px; left: 0; width: 100%; text-align: center; margin-top: 8px; }
						.print-footer h4 { font-size: 10pt; }
						.size-item{display:inline-block;white-space:pre}
						</style>
</head>
					<body>
						${printHTML}
					</body>
					</html>`;

					// Get document ID by submitting to the API
					const documentResponse = await this.$http.post("api/document", printDoc, {
						headers: {
							"Content-Type": "text/html",
						},
					});

					const documentId = documentResponse.data.docId;

					// Create print options
					const printOptions = {
						copies: parseInt(this.copies, 10),
						color: false,
						duplex: false,
						collate: true,
						paperSize: "letter",
					};

					// Add metadata for print job logging
					const metadata = {
						documentType: 4, // PurchaseOrder = 4 (from enum)
						documentNumber: po.orderNumber,
						purchaseOrderId: po.purchaseOrderId,
						salesOrderId: po.salesOrderId,
						message: this.printMessage,
					};

					// Send the print job request
					const printResponse = await this.$http.post(
						`/api/print/document`,
						{
							documentId: documentId,
							printerId: this.printerSelection,
							options: printOptions,
							metadata: metadata,
						}
					);

					// Handle responses that might not have expected structure
					if (printResponse && printResponse.data) {
						this.printJobId = printResponse.data.jobId || "unknown";
					} else {
						this.printJobId = "unknown";
					}
				}

				this.loading = false;

				// Show success message in both the alert and snackbar
				const printerName =
					this.printers.find((p) => p.printerId === this.printerSelection)?.text ||
					"selected printer";

				this.printResult = {
					show: true,
					type: "success",
					message: `Purchase Order${
						this.info.length > 1 ? "s" : ""
					} successfully sent to ${printerName}`,
				};

				// Display snackbar notification
				this.snackbar = {
					show: true,
					color: "success",
					text: this.printResult.message,
					timeout: 5000,
				};

				// Only hide the modal after a short delay to allow users to see the success message
				setTimeout(() => {
					this.showPrintModal = false;
					this.isPrinting = false;
				}, 2000);
			} catch (error) {
				console.error("Error printing document:", error);

				// Handle different error types with a safe extraction of error message
				let errorMessage = "Unknown error occurred";
				try {
					if (error.response && typeof error.response.data === "string") {
						errorMessage = error.response.data;
					} else if (error.message) {
						errorMessage = error.message;
					}
				} catch (e) {
					console.error("Error extracting error message:", e);
				}

				this.printResult = {
					show: true,
					type: "error",
					message: `Print failed: ${errorMessage}`,
				};

				// Display snackbar notification
				this.snackbar = {
					show: true,
					color: "error",
					text: this.printResult.message,
					timeout: 5000,
				};

				this.loading = false;
				this.isPrinting = false;
			}
		},

		async getInventoryColors(items) {
			const inventoryIdsWithColors = items.reduce(
				(acc, el) =>
					el.colors?.length > 0 ||
					el.colorSelections?.length > 0 ||
					el.freeTextSelections?.length > 0
						? [...acc, el.itemOrdered.inventoryItemId]
						: acc,
				[]
			);
			let colorOptions = [];
			if (inventoryIdsWithColors.length) {
				const inventories = await this.$apollo.query({
					fetchPolicy: "no-cache",
					query: GET_INVENTORY_COLOR_OPTIONS_IDS,
					variables: {
						where: {
							inventoryItemId: {
								in: inventoryIdsWithColors,
							},
						},
					},
				});
				inventories.data.response.items.forEach((inventory) => {
					inventory.colorOptions.forEach((option) => {
						const colorDescription = option.description;
						const colorOption = option.name;
						const colorOptionId = option.colorOptionId;
						option.colorPalettes.forEach((colorPalette) => {
							colorPalette.colors.forEach((color) => {
								colorOptions[color.colorId] = {
									...color,
									colorDescription,
									colorOptionId,
									colorOption,
								};
							});
						});
					});
				});
			}
			return colorOptions;
		},

		async getInventoryColorOptions(items) {
			const inventoryIdsWithColors = items.reduce(
				(acc, el) =>
					el.colors?.length > 0 ||
					el.colorSelections?.length > 0 ||
					el.freeTextSelections?.length > 0
						? [...acc, el.itemOrdered.inventoryItemId]
						: acc,
				[]
			);
			let colorOptions = [];
			if (inventoryIdsWithColors.length) {
				const inventories = await this.$apollo.query({
					fetchPolicy: "no-cache",
					query: GET_INVENTORY_COLOR_OPTIONS_IDS,
					variables: {
						where: {
							inventoryItemId: {
								in: inventoryIdsWithColors,
							},
						},
					},
				});
				return inventories.data.response.items;
			}
			return colorOptions;
		},

		formatNewLines(text) {
			if (!text) return "";
			return text.replace(/\n/g, "<br/>").replace(/\t/g, "&emsp;");
		},

		async getLineItems() {
			if (this.orderId) {
				const res = await this.$http.get(`/api/orders/${this.orderId}/lineItems`);
				return res.data.lineItems;
			}

			return [];
		},

		toLineItemSummary(lineItem) {
			return {
				...lineItem,
				children: lineItem.children?.map((c) => this.toLineItemSummary(c)),
			};
		},

		flattenLineItems(lineItems) {
			let itemsArr = [];
			lineItems.forEach((li) => itemsArr.push(...this.flattenLineItem(li)));

			return itemsArr;
		},

		flattenLineItem(lineItem) {
			let lineItems = [lineItem];

			if (lineItem.children?.length > 0) {
				lineItem.children.forEach((child) => {
					lineItems.push(...this.flattenLineItem(child));
				});
			}

			return lineItems;
		},

		async recordPrintAction(purchaseOrderId) {
			await this.$http.post(`/api/purchasing/orders/${purchaseOrderId}/print/po`);
		},

		async searchCustomerAddresses(input) {
			const searchTerm = input?.replace(/\s/g, "+");
			const response = await this.$apollo.query({
				query: gql`
		                query {
		                    searchCustomers(searchTerm: "${searchTerm}") {
		                        items {
		                            customerId
		                            customerNumber
		                            organization
		                            addresses {
		                                addressId
		                                label
		                                addressLine1
		                                addressLine2
		                                addressTypeId
		                                city
		                                state
		                                postalCode
		                            }
									contacts {
										contactId
										contactTypeId
										primaryContact
										firstName
										middleName
										lastName
										workPhoneNumber
										cellPhoneNumber
										email
										isActive
									}
		                        }
		                        pageInfo {
		                            hasNextPage
		                            hasPreviousPage
		                        }
		                    }
		                }
				    `,
				fetchPolicy: "no-cache",
			});

			const customers = response.data.searchCustomers.items;
			this.setShipToResults(customers);
		},

		async getCustomerById(customerId) {
			const response = await this.$apollo.query({
				query: gql`
		                query GetCustomerById{
							customerById(id: ${customerId}) {
								customerId
								customerNumber
								organization
								addresses {
								addressId
								label
								addressLine1
								addressLine2
								addressTypeId
								city
								state
								postalCode
								}
								contacts {
								contactId
								contactTypeId
								primaryContact
								firstName
								middleName
								lastName
								workPhoneNumber
								cellPhoneNumber
								email
								isActive
								}
							}
							}

				    `,
				fetchPolicy: "no-cache",
			});

			const customers = response.data.customerById;
			this.setShipToResults(customers);
		},

		setShipToResults(customers) {
			if (!customers && !this.salesOrder?.customer?.customer) {
				console.error("Customer is undefined:", customers);
				this.shipToResults = [];
				return;
			}

			const customerArray =
				customers && Array.isArray(customers)
					? customers
					: customers
					? [customers]
					: [this.salesOrder?.customer?.customer];

			this.shipToResults = customerArray.flatMap((customer) => {
				const addresses = Array.isArray(customer.addresses)
					? customer.addresses.map((address) => ({
							...address,
							customerName: customer.organization,
							isVendor: false,
					  }))
					: [];

				const contacts = Array.isArray(customer.contacts)
					? customer.contacts.map((contact) => ({
							...contact,
							customerName: customer.organization,
							isVendor: false,
					  }))
					: [];

				return contacts.flatMap((contact) =>
					addresses.map((address) => ({
						...contact,
						...address,
					}))
				);
			});
		},

		async findShipTo(customerAddressId, contactId) {
			const customer = await this.$apollo.query({
				query: CUSTOMER_ADDRESS_BY_ID,
				variables: { id: customerAddressId || this.customer?.shipTo },
			});

			const customerId = customer?.data?.customerAddressById?.customer?.customerId;

			if (customerId) {
				await this.getCustomerById(customerId);
			} else {
				await this.searchCustomerAddresses(
					customer?.data?.customerAddressById?.customer?.organization
				);
			}

			return this.shipToResults?.find(
				(str) => str.addressId === customerAddressId && str.contactId === contactId
			);
		},

		async getShipTo(po) {
			let salesOrderShipTo = null;
			let salesOrderContactId = null;

			if (po.salesOrderId) {
				const orderRes = await this.$apollo.query({
					query: GET_SALES_ORDER,
					variables: { id: this.orderId },
					fetchPolicy: "no-cache",
				});

				this.salesOrder = orderRes.data.salesOrderById;
				await this.setShipToResults();

				if (this.salesOrder?.customer) {
					salesOrderShipTo = this.salesOrder.customer.shipTo;
					salesOrderContactId = this.salesOrder.customer.contactId;
				}
			}

			if (po.dropShip) {
				// DropShip POs must ship to the sales order's Ship To. Use the sales
				// order's customer data directly (already loaded above) instead of
				// round-tripping through customerAddressById — the PO's stored
				// customerAddressId is unreliable (IPurchasingService populates it
				// with CustomerId, not AddressId).
				if (this.salesOrder?.customer?.customer) {
					return {
						customer: this.salesOrder.customer.customer,
						salesOrderShipTo,
						salesOrderContactId,
					};
				}

				// Fallback when no sales order is linked: honor an explicit customer
				// prop if provided, otherwise the PO's customerAddressId (best-effort).
				const addressIdToFetch = this.customer?.shipTo || po.customerAddressId;
				if (addressIdToFetch) {
					const customer = await this.$apollo.query({
						query: CUSTOMER_ADDRESS_BY_ID,
						variables: { id: addressIdToFetch },
					});

					return {
						customer: customer?.data?.customerAddressById?.customer || null,
						salesOrderShipTo,
						salesOrderContactId,
					};
				}
			} else if (po.customerAddressId) {
				return await this.findShipTo(po.customerAddressId, po.contactId);
			}

			return null;
		},

		getContactName(shipTo, purchaseOrder = null) {
			if (!shipTo || !shipTo.customer?.contacts) return shipTo?.organization || "";

			// The Ship To block should name the contact linked to the shipping
			// address itself (e.g. the teacher at a school), not the sales order's
			// main contact — they are often different people.
			const addressId = this.customer?.shipTo || shipTo?.salesOrderShipTo || purchaseOrder?.customerAddressId;
			const address = addressId
				? shipTo.customer.addresses?.find((a) => a.addressId === addressId)
				: null;

			// Priority: address-linked contact > customer prop > sales order contact > PO contact
			const contactId =
				address?.contactId ||
				this.customer?.contactId ||
				shipTo?.salesOrderContactId ||
				purchaseOrder?.contactId;

			if (contactId) {
				const contact = shipTo.customer.contacts.find((c) => c.contactId === contactId);
				if (contact && (contact.firstName || contact.lastName)) {
					return `${contact.firstName || ""} ${contact.lastName || ""}`.trim();
				}
			}

			// Fall back to primary contact
			const primaryContact = shipTo.customer.contacts.find((c) => c.primaryContact);
			if (primaryContact && (primaryContact.firstName || primaryContact.lastName)) {
				return `${primaryContact.firstName || ""} ${primaryContact.lastName || ""}`.trim();
			}

			return shipTo.customer?.organization || "";
		},

		getOrganization(shipTo) {
			if (shipTo?.customer?.organization) {
				return shipTo.customer.organization;
			} else if (shipTo) {
				return shipTo.customerName;
			}
			return "";
		},

		getAddress(shipTo, field, purchaseOrder = null) {
			if (!shipTo || !shipTo.customer?.addresses) return "";

			// Priority: customer prop > salesOrderShipTo > PO customerAddressId
			// (PO.customerAddressId is unreliable — see getShipTo for details)
			const addressId = this.customer?.shipTo || shipTo?.salesOrderShipTo || purchaseOrder?.customerAddressId;
			if (!addressId) return "";

			const address = shipTo.customer.addresses.find((a) => a.addressId === addressId);

			return address ? address[field] || "" : "";
		},

		async processParentItem(parentItem) {
			let parentPoId = parentItem.parentPoId;
			if (parentPoId) {
				const parentRes = await this.$apollo.query({
					fetchPolicy: "no-cache",
					query: PURCHASE_ORDER_BY_ID,
					variables: { id: parentPoId },
				});

				if (parentRes && parentRes.data && parentRes.data.purchaseOrderById) {
					const items = parentRes.data.purchaseOrderById.items;
					const matchingItem = items.find(
						(item) => item.salesOrderLineItemId === parentItem.parentLineItemId
					);
					if (matchingItem) {
						const parentColorOptions = await this.getInventoryColorOptions(items);

						return {
							...parentItem,
							...matchingItem,
							purchaseOrderNumber: parentRes.data.purchaseOrderById.purchaseOrderNumber,
							receivedItems: parentRes.data.purchaseOrderById.receivedItems,
							colorSelections: parentColorOptions
								.find((co) => co.inventoryItemId === matchingItem.itemOrdered.inventoryItemId)
								?.colorOptions.map((colorOption) => {
									let selection = matchingItem.colors.find(
										(c) => c.colorOptionId === colorOption.colorOptionId
									);
									if (!selection) {
										selection = matchingItem.colors.find((c) => c.colorOption === colorOption.name);
									}

									if (!selection) {
										selection = matchingItem.freeTextSelections.find(
											(c) => c.colorOptionId === colorOption.colorOptionId
										);
									}

									if (selection) {
										selection.colorDescription =
											colorOption.colorDescription || colorOption.description;
										selection.colorOption = colorOption.name;
										selection.colorOptionId = colorOption.colorOptionId;
										selection.colorOptionPosition = colorOption.position;
									}

									return selection;
								})
								.filter(Boolean)
								.sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0)) || [],
						};
					}
				}
			} else if (parentItem.parentLineItemId) {
				let lineItem = this.lineItems.find((li) => li.lineItemId === parentItem.parentLineItemId);
				if (!lineItem) return parentItem;
				return {
					...parentItem,
					...lineItem,
					itemOrdered: {
						description: lineItem.description,
						inventoryItemId: lineItem.itemId,
						processTypeId: lineItem.processTypeId,
						styleCode: lineItem.styleCode,
						systemCategoryId: lineItem.systemCategoryId,
						systemCategory: this.$systemCategories.getSystemCategory(lineItem.systemCategoryId)
							?.name,
					},
				};
			}
			return parentItem;
		},

		async processItems(items, key) {
			let updatedItems = [];
			for (let item of items) {
				if (item[`${key}PoId`]) {
					const itemRes = await this.$apollo.query({
						fetchPolicy: "no-cache",
						query: PURCHASE_ORDER_BY_ID,
						variables: { id: item[`${key}PoId`] },
					});

					if (itemRes && itemRes.data && itemRes.data.purchaseOrderById) {
						const matchingItem = itemRes.data.purchaseOrderById.items.find(
							(i) => i.salesOrderLineItemId === item.lineItemId
						);
						if (matchingItem) {
							const itemColorOptions = await this.getInventoryColorOptions(
								itemRes.data.purchaseOrderById.items
							);

							updatedItems.push({
								...item,
								...matchingItem,
								isAttaching: key === "attach",
								purchaseOrderNumber: itemRes.data.purchaseOrderById.purchaseOrderNumber,
								receivedItems: itemRes.data.purchaseOrderById.receivedItems,
								colorSelections: Array.isArray(itemColorOptions)
									? itemColorOptions
											?.find(
												(co) => co.inventoryItemId === matchingItem.itemOrdered.inventoryItemId
											)
											?.colorOptions.map((colorOption) => {
												let selection = matchingItem.colors.find(
													(c) => c.colorOptionId === colorOption.colorOptionId
												);
												if (!selection) {
													selection = matchingItem.colors.find(
														(c) => c.colorOption === colorOption.name
													);
												}

												if (!selection) {
													selection = matchingItem.freeTextSelections.find(
														(c) => c.colorOptionId === colorOption.colorOptionId
													);
												}

												if (selection) {
													selection.colorDescription =
														colorOption.colorDescription || colorOption.description;
													selection.colorOption = colorOption.name;
													selection.colorOptionId = colorOption.colorOptionId;
													selection.colorOptionPosition = colorOption.position;
												}

												return selection;
											})
											.filter(Boolean)
											.sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0)) || []
									: [],
							});
						}
					}
				}
			}
			return updatedItems;
		},

		async processPurchaseOrder(purchaseOrderId) {
			await this.recordPrintAction(purchaseOrderId);

			const res = await this.$apollo.query({
				fetchPolicy: "no-cache",
				query: PURCHASE_ORDER_BY_ID,
				variables: { id: purchaseOrderId },
			});

			if (res?.data?.purchaseOrderById) {
				const po = res.data.purchaseOrderById;
				this.orderId = po.salesOrderId;

				if (this.lineItems.length === 0) {
					let lineItems = await this.getLineItems();
					let flattenedLineItems = this.flattenLineItems(lineItems);
					flattenedLineItems.forEach((li, index) => (li.lineNumber = index + 1));
					this.lineItems = flattenedLineItems.map((li) => this.toLineItemSummary(li));
				}

				let shipTo = await this.getShipTo(po);
				let parentItem = await this.processParentItem(po.parentItem);
				let updatedChildItems = await this.processItems(po.childItems, "child");
				let updatedAttachItems = await this.processItems(po.attachItems, "attach");
				let updatedSiblingItems = await this.processItems(po.siblingItems || [], "sibling");

				const colorOptions = await this.getInventoryColorOptions(po.items);

				// Reqd Date: fall back to PO date + 2 weeks for POs created
				// before ExpectedDate was persisted server-side (#1229).
				const expectedDate = po.expectedDate ?? this.addDaysToDate(po.purchaseOrderDate, 14);

				let poData = {
					...po,
					purchaseOrderId: po.id,
					dropShip: po.dropShip,
					expectedDate,
					expectedShipDate: expectedDate,
					orderNumber: po.purchaseOrderNumber,
					orderDate: po.purchaseOrderDate,
					customerNumber: po.salesOrderId,
					// Fall back to the sales order's shipping method when the PO has none,
					// so "Ship Via" renders consistently from every entry point
					// (OrderView passes shippingMethodId as a prop; PurchaseOrderView and
					// AutoPrintPurchaseOrder do not).
					shippingMethodId: po.shippingMethodId ?? this.salesOrder?.shippingMethodId ?? null,
					shipTo,
					notes: po.notes.map((note) => ({
						...note,
						noteDate: note.createdAt,
						note: note.noteText,
						author: note.createdBy,
					})),
					items: po.items.map((item) => ({
						...item,
						quantity: item.quantity,
						unitPrice: item.unitPrice,
						totalSizes: item.totalSizes,
						hasSizes: item.hasSizes,
						itemOrdered: item.itemOrdered,
						sizeSelections: item.sizes.map((size) => ({
							...size,
							name: size.size,
							length: size.length,
							quantity: size.quantity,
						})),
						specialSizeSelections: item.specialSizes,
						colorSelections: Array.isArray(colorOptions)
							? colorOptions
									.find((co) => co.inventoryItemId === item.itemOrdered.inventoryItemId)
									?.colorOptions.map((colorOption) => {
										let selection = item.colors.find(
											(c) => c.colorOptionId === colorOption.colorOptionId
										);

										if (!selection) {
											selection = item.colors.find((c) => c.colorOption === colorOption.name);
										}

										if (!selection) {
											selection = item.freeTextSelections.find(
												(c) => c.colorOptionId === colorOption.colorOptionId
											);
										}

										if (selection) {
											selection.colorDescription =
												colorOption.colorDescription || colorOption.description;
											selection.colorOption = colorOption.name;
											selection.colorOptionId = colorOption.colorOptionId;
											selection.colorOptionPosition = colorOption.position;
										}

										return selection;
									})
									.filter(Boolean)
									.sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0)) || []
							: [],
						styleCode: item.itemOrdered.styleCode,
						systemCategoryId:
							this.$store.state.systemCategories.systemCategories.find(
								(el) => el.name === item?.itemOrdered?.systemCategory
							)?.systemCategoryId ||
							item.systemCategoryId ||
							0,
						description: item.itemOrdered.description,
						inventoryItemId: item.itemOrdered.inventoryItemId,
						vendorCost: item.unitPrice,
						parentItem,
						childItems: updatedChildItems,
						attachItems: updatedAttachItems,
						siblingItems: updatedSiblingItems,
					})),
				};

				const resVendor = await this.$apollo.query({
					fetchPolicy: "no-cache",
					query: VENDOR_BY_ID,
					variables: { id: po.vendorId },
				});

				const vendorSearch = resVendor.data.response;
				poData.vendorAddress =
					vendorSearch.addresses?.find((el) => el.isPrimaryAddress) ||
					(vendorSearch.addresses?.length > 0 ? vendorSearch.addresses[0] : {});
				poData.companyName = vendorSearch.companyName;
				// Only pass the rep when THIS po is order-linked — this.salesOrder
				// can hold a previous PO's order in multi-PO print runs.
				poData.orderedBy = await this.renderOrderedBy(
					po.createdBy,
					po.salesOrderId ? this.salesOrder?.salesRepId : null
				);
				this.info.push(poData);
			}
		},

	async download() {
		// Download print documents for all purchase orders
		if (!this.info || this.info.length === 0) {
			console.error("No purchase orders available to download");
			return;
		}

		this.isDownloading = true;

		try {
			// Download each purchase order
			for (const po of this.info) {
				await this.downloadSinglePurchaseOrder(po);
				// Add a small delay between downloads to avoid overwhelming the browser
				if (this.info.length > 1) {
					await new Promise(resolve => setTimeout(resolve, 500));
				}
			}

			// Show success notification
			this.snackbar = {
				show: true,
				message: 'Purchase order' + (this.info.length > 1 ? 's' : '') + ' downloaded successfully',
				color: 'success',
				timeout: 5000,
			};
		} catch (error) {
			console.error("Error downloading purchase orders:", error);
			// Show error notification
			this.snackbar = {
				show: true,
				message: "Failed to download purchase order(s). Please try again.",
				color: 'error',
				timeout: 5000,
			};
		} finally {
			this.isDownloading = false;
		}
	},

	generatePurchaseOrderDocument(printHTML, purchaseOrderId) {
		/* eslint-disable */
		// Use local PagedJS - no CDN dependencies
		const pagedJsScript = pagedJSService.getPagedJSScriptTag({
			inline: false
		});

		return `<!DOCTYPE html>
		<html>
		<head>
			${pagedJsScript}
			<script>
				class Sanitize extends Paged.Handler {
					constructor(chunker, polisher, caller) {
						super(chunker, polisher, caller);
					}
					afterPageLayout(pageFragment, page) {
						const contentElements = document.querySelectorAll('.pagedjs_page_content');
						contentElements.forEach(element => {
							let style = element.getAttribute("style");
							if (style) {
								style = style.replace(/column-width:[^;]+;?/, '');
								element.setAttribute("style", style);
							}
						});
					}

					afterRendered(pages) {
						// Set completion flag for server-side PDF generation
						window.__pagedjs_complete = true;

						// Fix "Page X of 0" - counter(pages) is unreliable in running elements
						const totalPages = pages.length;
						document.querySelectorAll('.pagedjs_page').forEach((pageEl, index) => {
							const pageNumberEl = pageEl.querySelector('.page-number');
							if (pageNumberEl) {
								pageNumberEl.textContent = 'Page ' + (index + 1) + ' of ' + totalPages;
							}
						});
					}
				}
				Paged.registerHandlers(Sanitize);
			<\/script>
			<style type="text/css">
				*, ::after, ::before { box-sizing: border-box; margin: 0; padding: 0; }
				body{counter-reset: page;}
				@page { size: Letter; margin: 0.4cm; margin-top: 3cm; margin-bottom: 0.9cm; @top-center{content:element(pageHeader)} @bottom-center{content:element(pageIdFooter)} }
				.print-${purchaseOrderId} { position: relative; display: contents; background-color: #fff; line-height: 14pt; font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif !important; width: 100%; }
				.print-wrapper { height: 100%; }
				.po-cancelled { position: relative; opacity: 0.45; }
				.po-cancelled::after { content: "CANCELLED"; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(-18deg); font-size: 6rem; font-weight: 900; letter-spacing: 1rem; color: rgba(0, 0, 0, 0.08); white-space: nowrap; pointer-events: none; z-index: 1; }
				.page-id-footer{position:running(pageIdFooter);font-family:Arial,sans-serif;font-size:9pt;color:#555;text-align:center;padding:4px 0}
				.page-id-footer .page-number::after{content:none}
				.print-heading { position: running(pageHeader); display: block; }
				.print-heading p { font-size: 12pt; font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif; margin-bottom: 8px !important; }
				.print-heading-logo { display: block; width: 100%; text-align: center; }
				.print-heading-logo img { max-width: 70%; height: auto; }
				.print-heading-type { display: inline-block; width: 100%; padding: 4px; margin-bottom: 8px; text-align: center; font-size: 10pt; background-color: #000; color: #fff; }
						.header-page-number::after { content: "Page " counter(page); }
				.print-heading-left { display: inline-block; width: 25%; text-align: left; vertical-align: top; }
				.print-heading-center { display: inline-block; width: 50%; vertical-align: top; }
				.print-heading-right { display: inline-block; width: 25%; font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif; text-align: right; vertical-align: top; }
				.print-info { display: flex; margin-bottom: 8px; }
				.print-info-container-split { display: flex; width: 48%; }
				.print-info-container-split:last-child { margin-left: 4%; }
				.print-info-container-split table { width: 100%; border-spacing: 0px; font-size: 10pt; border: 1px solid #000; }
				.print-info-container-split table thead tr { page-break-inside: avoid; }
				.print-info-container-split table thead tr th { padding: 4px; background-color: #000; color: #fff; text-align: center; font-weight: 400; }
				.print-info-container-split table tbody tr { page-break-inside: avoid; }
				.print-info-container-split table tbody tr td { padding: 5px; padding-left: 15px; display: flex; flex-direction: column; }
				.print-info-container-split table tbody tr td p:nth-child(4) { margin-bottom: 20px !important; }
				.print-info-container-full { display: block; width: 100%; }
				.print-info-container-full table { width: 100%; border-spacing: 0px; font-size: 10pt; border: 1px solid #000; }
				.print-info-container-full table thead tr { page-break-inside: avoid; }
				.print-info-container-full table thead tr th { padding: 4px; background-color: #000; color: #fff; text-align: center; font-weight: 400; }
				.print-info-container-full table tbody tr { page-break-inside: avoid; }
				.print-info-container-full table tbody tr td { padding: 4px; text-align: center; border-right: 1px solid #000; }
				.print-info-container-full table tbody tr td:last-child { border-right: none; }
				.print-items { display: block; }
				.print-items-container { display: block; width: 100%; }
				.print-items-container table { width: 100%; border-spacing: 0px; border: 1px solid #000; }
				.print-items-container table thead tr { page-break-inside: avoid; }
				.print-items-container table thead tr th { font-size: 10pt; padding: 4px 2px; background-color: #000; color: #fff; text-align: center; font-weight: 400; }
				.print-items-container table tbody tr { break-inside: avoid; page-break-inside: avoid; }
				.print-items-container table tbody tr td { font-size: 9pt; vertical-align: top; padding:3px 2px; text-align: center; border-right: 1px solid #000; line-height:14px }
				.print-items-container table tbody tr td:last-child { border-right: none; }
				.print-items-container table tbody tr td:nth-child(1) { width: 50px; }
				.print-items-container table tbody tr td:nth-child(2) { width: 16%; text-align: left; }
				.print-items-container table tbody tr td:nth-child(3) { text-align: left; }
				.print-items-container table tbody tr td:nth-child(4) { width: 16%; text-align: right; }
				.print-items-container table tbody tr td:nth-child(5) { width: 16%; text-align: right; }
				.print-items-title { font-weight: 700; }
				.print-items-value { font-weight: 700; }
				.print-items-container table tfoot tr td { font-size: 10pt; font-weight: 700; padding: 8px 4px; border-top: 2px solid #000; background-color: #f2f2f2; }
				.print-items-container table tfoot tr td.order-total-label { text-align: right; padding-right: 8px; }
				.print-items-container table tfoot tr td.order-total-amount { text-align: right; }
				.print-footer { position: absolute; bottom: -15px; left: 0; width: 100%; text-align: center; margin-top: 8px; }
				.print-footer h4 { font-size: 10pt; }
			.size-item{display:inline-block;white-space:pre}
			</style>
</head>
		<body>${printHTML}</body>
		</html>`;
	},

	onPdfIframeLoad(purchaseOrderId) {
		if (!this.pdfUrls[purchaseOrderId]) return;
		console.log(`[POPrintTemplate] PDF preview loaded for PO ${purchaseOrderId}`);
		this.pdfReadySet = new Set([...this.pdfReadySet, Number(purchaseOrderId)]);
		const expectedIds = this.purchaseOrderIds.map(id => Number(id));
		const allComplete = expectedIds.length > 0
			&& expectedIds.every(id => this.pdfReadySet.has(id));
		if (allComplete) {
			console.log('[POPrintTemplate] All PDF previews loaded');
			this.$emit('pagedjs-complete');
		}
	},

	async downloadSinglePurchaseOrder(po) {
		console.log('Generating download for purchase order ' + po.purchaseOrderId + '...');

		// Get the HTML for the specific purchase order
		let printHTML = '';
		const poElement = document.querySelector('.print-' + po.purchaseOrderId);
		if (poElement) {
			printHTML = poElement.parentElement.innerHTML;
		} else {
			console.error('Could not find print element for purchase order ' + po.purchaseOrderId);
			return;
		}

		// Generate the print document with complete CSS
		const printDoc = this.generatePurchaseOrderDocument(printHTML, po.purchaseOrderId);

		// Post the document to the API to get a document ID
		const response = await this.$http.post("api/document", printDoc, {
			headers: {
				"Content-Type": "text/html",
			},
		});

		const documentId = response.data.docId;

		// Open the download URL with metadata in query parameters for better filename
		const downloadUrl = '/api/document/' + documentId + '?type=purchase-order&id=' + po.purchaseOrderId;
		window.open(downloadUrl);

		console.log('Downloaded purchase order #' + po.orderNumber);
	},
	},
	computed: {
		isFormValid() {
			return this.printerSelection && this.copies && this.copies > 0;
		},
		pagedJsComplete() {
			if (this.purchaseOrderIds.length === 0) return false;
			return this.purchaseOrderIds.every(id => this.pdfReadySet.has(Number(id)));
		},
	},
	beforeDestroy() {
		Object.values(this.pdfUrls).forEach(url => URL.revokeObjectURL(url));
	},
	async mounted() {
		// the order view keeps its scroll position when routing to the print preview
		window.scrollTo(0, 0);

		this.loading = true;

		for (let purchaseOrderId of this.purchaseOrderIds) {
			await this.processPurchaseOrder(purchaseOrderId);
		}

		// Cancelled POs still print (with a CANCELLED watermark) but are pushed to the
		// bottom, mirroring the receiving-entry layout. Stable sort keeps the original
		// order within each group.
		this.info.sort((a, b) => {
			if (!!a.isCancelled !== !!b.isCancelled) return a.isCancelled ? 1 : -1;
			return 0;
		});

		this.$nextTick(async () => {
			await new Promise(resolve => setTimeout(resolve, 2000));

			for (let po of this.info) {
				const printElement = document.querySelector(`.print-${po.purchaseOrderId}`);
				if (!printElement) {
					console.error(`Print element not found for PO ${po.purchaseOrderId}. The template may have failed to render.`);
					this.snackbar = {
						show: true,
						color: 'error',
						text: `Failed to render Purchase Order ${po.orderNumber || po.purchaseOrderId}. Please check if all data is valid.`,
						timeout: 10000
					};
					continue;
				}

				if (!this.skipPreview) {
					const printHTML = printElement.parentElement.innerHTML;
					const printDoc = this.generatePurchaseOrderDocument(printHTML, po.purchaseOrderId);

					try {
						const response = await this.$http.post("api/document", printDoc, {
							headers: { "Content-Type": "text/html" },
						});
						const docId = response.data.docId;
						const pdfResponse = await this.$http.get(`/api/document/${docId}`, {
							responseType: 'blob',
						});
						const blobUrl = URL.createObjectURL(pdfResponse.data);
						this.$set(this.pdfUrls, po.purchaseOrderId, blobUrl + '#navpanes=0&view=FitH');
					} catch (err) {
						console.error(`Failed to generate PDF preview for PO ${po.purchaseOrderId}:`, err);
						this.snackbar = {
							show: true,
							color: 'error',
							text: `Failed to generate preview for PO ${po.orderNumber || po.purchaseOrderId}.`,
							timeout: 10000
						};
					}
				}
			}

			this.loading = false;

			if (this.skipPreview) {
				this.$emit('pagedjs-complete');
			}
		});

		// Load printers from API
		try {
			const response = await this.$http.get(`/api/print/printers`);
			const printersData = response.data.printers || response.data;
			this.printers = printersData.map((printer) => ({
				printerId: printer.id,
				text: `${printer.name} (${printer.location || "No location"})`,
				status: printer.status,
			}));

			// Set default values for print modal
			if (this.printers.length > 0) {
				const onlinePrinter = this.printers.find((p) => p.status === "Online");
				this.printerSelection = onlinePrinter
					? onlinePrinter.printerId
					: this.printers[0].printerId;
			}
			this.copies = 1;
		} catch (error) {
			console.error("Error loading printers:", error);
		}
	},
};
</script>

<style lang="scss" scoped>
.button-group {
	display: flex;
	align-items: center;
}

.message-input {
	width: 100;
}
#print-frame,
.print-frame {
	display: block;
	background-color: #f5f5f5;
	width: 100%;
	max-width: 900px;
	aspect-ratio: 8.5 / 11.5;
	margin: 0 auto;
	border: none;
}

// keep the action buttons visible below the fixed app bar while scrolling the document
.actions-col {
	position: sticky;
	top: 64px;
	z-index: 4;
	background-color: $color-gray-light;

	@media (max-width: 959px) {
		top: 56px;
	}
}

.actions {
	display: flex;
	width: 100%;
	justify-content: flex-end;

	.v-btn {
		background-color: $color-white;
		border-color: $color-gray;
		text-transform: initial;

		&:not(:last-child) {
			margin-right: 0.8rem;
		}
	}
}

.print {
	position: relative;
	background-color: $color-white;
	line-height: 14pt;
	font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif !important;
	width: 100%;
	//print css only
	// display: contents;
	//remove for printing css
	max-width: 1000px;
	min-height: 1300px;
	margin: auto;
	padding: 0.6cm;

	&-wrapper {
		height: 100%;
	}

	&-heading {
		display: block;
		margin-bottom: 12px;

		p {
			font-size: 12pt;
			margin-bottom: 8px !important;
		}

		&-logo {
			display: block;
			width: 100%;
			text-align: center;

			img {
				max-width: 70%;
				height: auto;
			}
		}

		&-type {
			display: inline-block;
			width: 100%;
			padding: 8px;
			margin-bottom: 8px;
			text-align: center;
			font-size: 10pt;
			background-color: $color-black;
			color: $color-white;
		}

		&-left {
			display: inline-block;
			width: 25%;
			text-align: left;
			vertical-align: top;
		}

		&-center {
			display: inline-block;
			width: 50%;
			vertical-align: top;
		}

		&-right {
			display: inline-block;
			width: 25%;
			text-align: right;
			vertical-align: top;
		}
	}

	&-info {
		display: block;
		margin-bottom: 8px;

		&-container-split {
			display: inline-block;
			width: 48%;

			&:last-child {
				margin-left: 4%;
			}

			table {
				width: 100%;
				border-spacing: 0px;
				font-size: 11pt;
				border: 1px solid $color-black;

				thead {
					tr {
						page-break-inside: avoid;

						th {
							padding: 8px;
							background-color: $color-black;
							color: $color-white;
							text-align: center;
							font-weight: normal;
						}
					}
				}

				tbody {
					tr {
						page-break-inside: avoid;

						td {
							padding: 20px;
							padding-left: 50px;

							p:nth-child(4) {
								margin-bottom: 20px !important;
							}
						}
					}
				}
			}
		}

		&-container-full {
			display: block;
			width: 100%;

			table {
				width: 100%;
				border-spacing: 0px;
				font-size: 11pt;
				border: 1px solid $color-black;

				thead {
					tr {
						page-break-inside: avoid;

						th {
							padding: 8px;
							background-color: $color-black;
							color: $color-white;
							text-align: center;
							font-weight: normal;
						}
					}
				}

				tbody {
					tr {
						page-break-inside: avoid;

						td {
							padding: 8px;
							text-align: center;
							border-right: 1px solid $color-black;

							&:last-child {
								border-right: none;
							}
						}
					}
				}
			}
		}
	}

	&-items {
		display: block;

		&-container {
			display: block;
			width: 100%;

			table {
				width: 100%;
				border-spacing: 0px;
				border: 1px solid $color-black;

				thead {
					tr {
						page-break-inside: avoid;

						th {
							font-size: 11pt;
							padding: 4px 2px;
							background-color: $color-black;
							color: $color-white;
							text-align: center;
							font-weight: normal;
						}
					}
				}

				tbody {
					tr {
						page-break-inside: avoid;

						td {
							font-size: 10pt;
							vertical-align: top;
							padding: 4px;
							text-align: center;
							border-right: 1px solid $color-black;

							&:last-child {
								border-right: none;
							}

							&:nth-child(1) {
								width: 50px;
							}

							&:nth-child(2) {
								width: 16%;
							}

							&:nth-child(3) {
								text-align: left;
							}

							&:nth-child(4) {
								width: 16%;
								text-align: right;
							}

							&:nth-child(5) {
								width: 16%;
								text-align: right;
							}
						}
					}
				}

					tfoot {
						tr {
							td {
								font-size: 11pt;
								font-weight: 700;
								padding: 8px 4px;
								border-top: 2px solid $color-black;
								background-color: #f2f2f2;

								&.order-total-label {
									text-align: right;
									padding-right: 8px;
								}

								&.order-total-amount {
									text-align: right;
								}
							}
						}
					}
				}
			}

		&-title {
			font-weight: 700;
		}

		&-value {
			font-weight: 700;
		}
	}

	&-footer {
		position: absolute;
		bottom: 40px;
		left: 0;
		width: 100%;
		text-align: center;
		margin-top: 8px;

		h4 {
			font-size: 10pt;
		}
	}
}

.print-modal {
	&-form {
		display: flex;
		flex-flow: column wrap;

		.form-input {
			margin: 0.75rem 0;

			.number-input {
				width: 14rem;
				flex: initial;
			}
		}
	}
}

.no-list-style {
	list-style: none;
	width: 100%;
	padding: 0;
	display: flex;
	flex-direction: column;

	li {
		width: 100%;
		margin-bottom: 100px;
	}
}
</style>
